"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _fieldStyles = require("./_fieldStyles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function CheckboxField(props) {
  const [checkedItems, setCheckedItems] = (0, _react.useState)(new Map());

  const handleCheckItem = e => {
    const {
      name,
      value
    } = e.target;
    let items = new Map(checkedItems);

    if (checkedItems.has(name)) {
      items.delete(name);
    } else {
      items.set(name, value);
    }

    setCheckedItems(items);
    props.setFieldValue(props.name, Array.from(items.values()).toString());
  };

  return /*#__PURE__*/_react.default.createElement(_fieldStyles.FieldContainer, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "label"
  }, props.label), props.options.map((opt, index) => {
    return /*#__PURE__*/_react.default.createElement(_fieldStyles.Label, {
      key: index
    }, /*#__PURE__*/_react.default.createElement("input", {
      type: "checkbox",
      name: props.name + "-" + index,
      value: opt,
      checked: checkedItems.get(props.name + "-" + index),
      onBlur: props.handleBlur,
      onChange: handleCheckItem
    }), opt);
  }), props.error && props.touched[props.name] && /*#__PURE__*/_react.default.createElement("div", {
    className: "error"
  }, props.error));
}

CheckboxField.propTypes = {
  label: _propTypes.default.string,
  name: _propTypes.default.string.isRequired,
  options: _propTypes.default.array,
  error: _propTypes.default.any,
  onChange: _propTypes.default.func.isRequired,
  setFieldValue: _propTypes.default.func.isRequired
};
var _default = CheckboxField;
exports.default = _default;